import React, { useEffect } from 'react';
import './LandingPage.css';
import PageHeader from './PageHeader';

const LandingPage = () => {
  useEffect(() => {
    document.title = 'LeapFrog Lab Registration Admin Portal';
  }, []);

  return (
    <div className="dashboard landing-page">
      <PageHeader title="Dashboard" />
      <main className="page-content">{/* Main content goes here */}</main>
    </div>
  );
};

export default LandingPage;
